__turbopack_context__.v({
  "container": "Vid_old-module__dnNlRq__container",
  "customBtnContainer": "Vid_old-module__dnNlRq__customBtnContainer",
  "customClose": "Vid_old-module__dnNlRq__customClose",
  "overlayBtn": "Vid_old-module__dnNlRq__overlayBtn",
  "videoModal": "Vid_old-module__dnNlRq__videoModal",
});
